export const ENTRIES_PER_PAGE = 8;
export const MONTHS_FORMAT = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
];
export const USER_USERNAME = 'trader';
export const USER_PASSWORD = 'app';
